export const getRootUrl = (url: string): string => {
    return `/${url.split('/')[1]}`
}
